export enum SignInType {
  EmailOrUsername,
  Username,
  ClassCode,
  Google,
  NSWDoE,
  CEnet,
}

export const TAB_OPTIONS = [
  { label: 'Email or Username', value: 'email-or-username' },
  { label: 'Username', value: 'username' },
  { label: 'Class Code', value: 'class-code' },
  { label: 'Google', value: 'google' },
  { label: 'NSW DoE', value: 'nsw-doe' },
  { label: 'CEnet', value: 'ce-net' },
];

type Props = {
  allStudentsHaveUsernames: boolean;
  isRegionAU: boolean;
};

export function getStudentSigninTabOptions({
  allStudentsHaveUsernames,
  isRegionAU,
}: Props) {
  if (allStudentsHaveUsernames) {
    return [
      TAB_OPTIONS[SignInType.Username],
      TAB_OPTIONS[SignInType.ClassCode],
    ];
  }
  // common tabs for all regions
  const commonTabs = [
    TAB_OPTIONS[SignInType.EmailOrUsername],
    TAB_OPTIONS[SignInType.Google],
    TAB_OPTIONS[SignInType.ClassCode],
  ];

  // AU specific tabs
  if (isRegionAU) {
    return [
      ...commonTabs,
      TAB_OPTIONS[SignInType.NSWDoE],
      TAB_OPTIONS[SignInType.CEnet],
    ];
  }

  return commonTabs;
}
